import { ComponentType } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CompatRouter, Route, Routes, useLocation, useParams } from 'react-router-dom-v5-compat';
import { ErrorBoundary } from 'survey/components';
import App, { SurveyRouteProps } from './App';
import Preview from './Preview';

// App and Preview are class components, so read the route data with hooks here and pass it as props.
const SurveyRoute = ({ component: Survey }: { component: ComponentType<SurveyRouteProps> }) => {
  const params = useParams();
  const location = useLocation();

  return (
    <ErrorBoundary>
      <Survey match={{ params }} location={location} />
    </ErrorBoundary>
  );
};

export const AppRouter = (): JSX.Element => (
  <Router>
    <CompatRouter>
      {/* Trailing /* keeps v5's non-exact matching for survey links with extra path segments. */}
      <Routes>
        <Route path="/surveys/:uuid/*" element={<SurveyRoute component={App} />} />
        <Route path="/preview/:uuid?/*" element={<SurveyRoute component={Preview} />} />
      </Routes>
    </CompatRouter>
  </Router>
);

export default AppRouter;
